import React, { useEffect } from 'react'
import SettingAside from '../SettingAside'
import { DrawerComponent, MenuComponent, ScrollComponent, ToggleComponent } from '../../../../assets/ts/components'
import UserManagementAside from '../UserManagementAside'
import { useNavigate } from 'react-router-dom'

function UserManagmentTab() {
  const navigate=useNavigate();
  useEffect(() => {
    navigate("/hr/user-managements/users/add-user")
  }, [])
      return (
        <div
          className='menu menu-column menu-fit menu-rounded menu-title-gray-600 menu-icon-gray-400 menu-state-secondary menu-state-icon-secondary menu-state-bullet-secondary menu-arrow-gray-500 fw-bold fs-5 px-6 my-5 my-lg-0'
          id='kt_aside_menu'
          data-kt-menu='true'
        >
          <div id='kt_aside_menu_wrapper' className='menu-fit'>
            <UserManagementAside />
          </div>
        </div>
      )
    }

export default UserManagmentTab;